/**
 * @generated SignedSource<<ea90c77ce6e5b76ffe999969ab089a9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type TaskExecutionOptionsSaveValueMutation$variables = {
  employeeId?: string | null;
  id: string;
  value?: TaskSentiment | null;
};
export type TaskExecutionOptionsSaveValueMutation$data = {
  readonly setTaskExecutionCheck: {
    readonly checkValue: TaskSentiment | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionListItemUpdatedInfo_taskExecution">;
  };
};
export type TaskExecutionOptionsSaveValueMutation$rawResponse = {
  readonly setTaskExecutionCheck: {
    readonly __isTaskExecution: "TaskExecutionCheck";
    readonly checkValue: TaskSentiment | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly lastUpdatedByActor: {
      readonly __typename: "ConnectActor";
      readonly __isActor: "ConnectActor";
      readonly employee: {
        readonly __typename: "Employee";
        readonly id: string;
        readonly image: {
          readonly __typename: "Image";
          readonly __isPublicAndInternalImage: "Image";
          readonly id: string;
          readonly sizes: ReadonlyArray<{
            readonly height: number;
            readonly id: string;
            readonly url: string;
            readonly urlExpiresAt: string | null;
            readonly width: number;
          }>;
          readonly thumbhash: string | null;
        } | {
          readonly __typename: "PublicImage";
          readonly __isPublicAndInternalImage: "PublicImage";
          readonly publicImageUrl: string;
        } | {
          readonly __typename: string;
          readonly __isPublicAndInternalImage: string;
        } | null;
        readonly name: string;
        readonly workStatus: EmployeeWorkStatus;
      } | null;
      readonly identifyingName: string | null;
    } | {
      readonly __typename: "GroupActor";
      readonly __isActor: "GroupActor";
      readonly employee: {
        readonly __typename: "Employee";
        readonly id: string;
        readonly image: {
          readonly __typename: "Image";
          readonly __isPublicAndInternalImage: "Image";
          readonly id: string;
          readonly sizes: ReadonlyArray<{
            readonly height: number;
            readonly id: string;
            readonly url: string;
            readonly urlExpiresAt: string | null;
            readonly width: number;
          }>;
          readonly thumbhash: string | null;
        } | {
          readonly __typename: "PublicImage";
          readonly __isPublicAndInternalImage: "PublicImage";
          readonly publicImageUrl: string;
        } | {
          readonly __typename: string;
          readonly __isPublicAndInternalImage: string;
        } | null;
        readonly name: string;
        readonly workStatus: EmployeeWorkStatus;
      } | null;
      readonly identifyingName: string | null;
      readonly user: {
        readonly __typename: "User";
        readonly id: string;
      } | null;
    } | {
      readonly __typename: "ScreenActor";
      readonly __isActor: "ScreenActor";
      readonly screen: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | {
      readonly __typename: "UserActor";
      readonly __isActor: "UserActor";
      readonly storeUser: {
        readonly employee: {
          readonly id: string;
          readonly image: {
            readonly __typename: "Image";
            readonly __isPublicAndInternalImage: "Image";
            readonly id: string;
            readonly sizes: ReadonlyArray<{
              readonly height: number;
              readonly id: string;
              readonly url: string;
              readonly urlExpiresAt: string | null;
              readonly width: number;
            }>;
            readonly thumbhash: string | null;
          } | {
            readonly __typename: "PublicImage";
            readonly __isPublicAndInternalImage: "PublicImage";
            readonly publicImageUrl: string;
          } | {
            readonly __typename: string;
            readonly __isPublicAndInternalImage: string;
          } | null;
          readonly name: string;
          readonly workStatus: EmployeeWorkStatus;
        } | null;
        readonly id: string;
        readonly user: {
          readonly email: string;
          readonly id: string;
          readonly name: string;
          readonly orgDescription: {
            readonly orgIconUri: string | null;
          } | null;
        };
      } | null;
    } | {
      readonly __typename: string;
      readonly __isActor: string;
    } | null;
    readonly updatedAtDate: {
      readonly storeFormattedDate: string;
    } | null;
  };
};
export type TaskExecutionOptionsSaveValueMutation = {
  rawResponse: TaskExecutionOptionsSaveValueMutation$rawResponse;
  response: TaskExecutionOptionsSaveValueMutation$data;
  variables: TaskExecutionOptionsSaveValueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "sentiment",
    "variableName": "value"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbhash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlExpiresAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v4/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskExecutionOptionsSaveValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TaskExecutionCheck",
        "kind": "LinkedField",
        "name": "setTaskExecutionCheck",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskExecutionListItemUpdatedInfo_taskExecution"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TaskExecutionOptionsSaveValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TaskExecutionCheck",
        "kind": "LinkedField",
        "name": "setTaskExecutionCheck",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "style",
                        "value": "DEFAULT"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "storeFormattedDate",
                    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "lastUpdatedByActor",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isActor"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreUser",
                        "kind": "LinkedField",
                        "name": "storeUser",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Employee",
                            "kind": "LinkedField",
                            "name": "employee",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgDescription",
                                "kind": "LinkedField",
                                "name": "orgDescription",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "orgIconUri",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "UserActor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StorecastScreen",
                        "kind": "LinkedField",
                        "name": "screen",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ScreenActor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "GroupActor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "type": "ConnectActor",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TaskExecution",
            "abstractKey": "__isTaskExecution"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cc778ae7c50952732d6107df3c405f7b",
    "id": null,
    "metadata": {},
    "name": "TaskExecutionOptionsSaveValueMutation",
    "operationKind": "mutation",
    "text": "mutation TaskExecutionOptionsSaveValueMutation(\n  $id: ID!\n  $value: TaskSentiment\n  $employeeId: ID\n) {\n  setTaskExecutionCheck(id: $id, sentiment: $value, employeeId: $employeeId) {\n    id\n    checkValue\n    isCompleted\n    ...TaskExecutionListItemUpdatedInfo_taskExecution\n  }\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment SignedActorBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on ConnectActor {\n    employee {\n      __typename\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment SignedActor_actor on Actor {\n  __isActor: __typename\n  ...Avatar_actor\n  ...SignedActorText_actor\n  ...SignedActorBadge_actor\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment TaskExecutionListItemUpdatedInfo_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  updatedAtDate {\n    ...StoreFormattedDate\n  }\n  isCompleted\n  lastUpdatedByActor {\n    __typename\n    ...SignedActor_actor\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd5748dc2a44f6d618a4fe20bf77e8cb";

export default node;
